export default [
  {
    id: 1,
    title: 'колледж',
    description: 'программы колледжа <br>рассчитаны на выпускников <br>9-х и 11-х классов',
    chips: ['3-4 года', '39 программ'],
    image: '/v2/catalog-abiturientam/cards/card-image-1.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'при выпуске вы получите среднее профессиональное образование',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
  {
    id: 2,
    title: 'бакалавриат',
    description: 'одна из законченных <br>ступеней высшего <br>образования',
    chips: ['4-4,5 года', '127 программ'],
    image: '/v2/catalog-abiturientam/cards/card-image-2.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'учеба предполагает фундаментальную подготовку и длится 4 года',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
  {
    id: 3,
    title: 'магистратура',
    description: 'следующий уровень <br>высшего образования',
    chips: ['2-2,5 года', '46 программ'],
    image: '/v2/catalog-abiturientam/cards/card-image-3.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'двухгодичное обучение с дальнейшим трудоустройством студентов',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
  {
    id: 4,
    title: 'аспирантура',
    description: 'программа для подготовки <br>по научным специальностям',
    chips: ['3 года', '21 программа'],
    image: '/v2/catalog-abiturientam/cards/card-image-4.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'программа для подготовки по научным специальностям',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
  {
    id: 5,
    title: 'второе высшее',
    description: 'программы по новым <br>направлениям',
    chips: ['3,6-4,6 года', '130 программ'],
    image: '/v2/catalog-abiturientam/cards/card-image-5.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'подходит тем, кто уже окончил бакалавриат или магистратуру',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
  {
    id: 6,
    title: 'специалитет',
    description: 'программа полного <br>высшего образования',
    chips: ['4 года', '13 программ'],
    image: '/v2/catalog-abiturientam/cards/card-image-6.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'включает в себя полный курс теоретических знаний и практических навыков, которые необходимы для работы по отраслевой специальности',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
  {
    id: 7,
    title: 'бизнес-<br>образование',
    description: '',
    chips: ['7 аккредитаций МВА', '42 программы'],
    image: '/v2/catalog-abiturientam/cards/card-image-7.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'с 1988 года мы помогаем компаниям, менеджерам и предпринимателям развиваться и достигать успехов, руководствуясь знаниями, практическим опытом и рекомендациями выдающихся спикеров и преподавателей. Лучшими становятся вместе с нами',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
  {
    id: 8,
    title: 'образование <br>за рубежом',
    description: '',
    chips: ['3-4 года', '18 программ'],
    image: '/v2/catalog-abiturientam/cards/card-image-8.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'получите уникальный опыт, расширяйте знания и карьерные возможности',
    price: {
      free: true,
      description: 'подберем программу и дадим доступ к вводной части обучения',
    },
  },
];
